export enum StepTypes {
  DEFAULT = 'default',
  CONTACT_FORM = 'contact-form',
  SUMMARY = 'summary',
  FINAL = 'final',
  NO_DATA = 'no-data',
}
